import prettyBytes from "pretty-bytes";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import DowloadIcon from "assets/icons/download.svg?react";
import { useState } from "react";
import AttachmentIconComponent from "components/AttachmentIconComponent";
import sanitizeHtml from "sanitize-html";
import { useDownloadFileStore } from "store/downloadFile.store";
import Loading from "components/Loading";
import { useDrag } from "react-dnd";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const LegalPersonAttachment: FC<Props> = ({
  date,
  attachment,
  onPreview,
  onDownload,
  className = "",
  disableMenu = false,
  sizeInColumn = false,
}) => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [{ opacity }, dragRef] = useDrag(
    () => ({
      type: "attachment",
      item: { id: attachment.Id },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1,
      }),
    }),
    []
  );

  const { id, progress } = useDownloadFileStore();

  const handleClickOnFile = (e: React.MouseEvent<HTMLDivElement>) => {
    const target: any = e.target;
    console.log(target);

    if (target.dataset.is) {
      onPreview(attachment);
      return;
    }
  };

  return (
    <div
      ref={dragRef}
      style={{ opacity }}
      data-is={true}
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
      onClick={handleClickOnFile}
      onDoubleClick={() => {
        // handleDoubleClick?.(attachment);
      }}
      className={`${styles.wrapper} ${className}`}
    >
      <div className={styles.content}>
        <div data-is={true}>
          <AttachmentIconComponent
            data-is={true}
            className={styles.iconPDF}
            file={attachment?.FileName ?? ""}
            onClick={() => handleClickOnFile}
          />
        </div>
        <div className={styles.metaData} data-is={true}>
          <div
            data-is={true}
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(attachment?.FileName),
            }}
          ></div>
          {!sizeInColumn && (
            <div data-is={true} className={styles.size}>
              {attachment?.Size &&
                attachment?.Size > 0 &&
                prettyBytes(attachment?.Size ?? 0)}{" "}
              {date && <>{date}</>}
            </div>
          )}
        </div>
        {showMenu && !disableMenu && (
          <div className={styles.menu}>
            <Tooltip title={t("common.download")}>
              <div>
                <DowloadIcon onClick={() => onDownload(attachment)} />
              </div>
            </Tooltip>
          </div>
        )}
        {sizeInColumn && (
          <div data-is={true} className={styles.size}>
            {attachment?.Size &&
              attachment?.Size > 0 &&
              prettyBytes(attachment?.Size ?? 0)}{" "}
            {date && <>{date}</>}
          </div>
        )}
        {/* {attachment.ShowInDossier > 0 &&
          !showMenu &&
          !disableMenu &&
          onAddDossier && (
            <Can I="accessModule" an="drive">
              <AttachIcon onClick={() => onAddDossier(attachment)} />
            </Can>
          )} */}
      </div>
      <div
        style={{
          width: id === attachment.Id ? `${progress}%` : "0%",
        }}
        className={styles.bar}
      ></div>
      {id === attachment.Id && (
        <div className={styles.loading}>
          <Loading withoutText />
        </div>
      )}
    </div>
  );
};

export default LegalPersonAttachment;
